// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--bHPbE";
export const category = "footer-module--category--U2bhJ";
export const categoryTitle = "footer-module--category-title--9V7Ly";